import React from 'react';
import { Star, CheckCircle } from 'lucide-react';
const reviews = [{
  initials: 'CM',
  name: 'Carlos M.',
  color: '#c0392b',
  text: 'Jugamos en familia y fue una noche épica. Los documentos son muy detallados y las pistas te hacen pensar de verdad. ¡Repetiremos!',
  stars: 5
}, {
  initials: 'LS',
  name: 'Laura S.',
  color: '#8e44ad',
  text: 'Perfecto para una noche diferente. Muy bien elaborado, con muchos detalles. Lo recomiendo 100%.',
  stars: 5
}, {
  initials: 'JR',
  name: 'Javier R.',
  color: '#2980b9',
  text: 'Increíble calidad. Pasamos 3 horas intentando resolver el caso y no nos dimos cuenta del tiempo.',
  stars: 5
}, {
  initials: 'AP',
  name: 'Ana P.',
  color: '#16a085',
  text: 'Lo compramos para una despedida y fue el plan estrella de la noche. Todos querían seguir jugando.',
  stars: 5
}, {
  initials: 'MT',
  name: 'Miguel T.',
  color: '#d35400',
  text: 'Muy bien pensado. Las pistas son coherentes y el final te sorprende. Excelente producto.',
  stars: 5
}, {
  initials: 'SL',
  name: 'Sofía L.',
  color: '#27ae60',
  text: 'Fácil de descargar y empezar. En 5 minutos ya estábamos metidos en el caso. ¡Genial!',
  stars: 5
}, {
  initials: 'RC',
  name: 'Roberto C.',
  color: '#c0392b',
  text: 'Lo jugamos en pareja y fue una cita muy original. Muy recomendable para salir de la rutina.',
  stars: 5
}, {
  initials: 'EV',
  name: 'Elena V.',
  color: '#8e44ad',
  text: 'Los 4 casos son muy diferentes entre sí. Cada uno tiene su propio estilo y dificultad. Vale mucho la pena.',
  stars: 5
}, {
  initials: 'DM',
  name: 'David M.',
  color: '#2980b9',
  text: 'Calidad impresionante por el precio. Los documentos parecen reales. Una experiencia única.',
  stars: 5
}, {
  initials: 'IF',
  name: 'Isabel F.',
  color: '#16a085',
  text: 'Perfecto para grupos grandes. Lo jugamos 8 personas y todos participaron. Muy entretenido.',
  stars: 5
}, {
  initials: 'PG',
  name: 'Pablo G.',
  color: '#d35400',
  text: 'El caso del tren es mi favorito. Muy bien construido el misterio. Ya estoy esperando nuevos casos.',
  stars: 5
}, {
  initials: 'CH',
  name: 'Carmen H.',
  color: '#27ae60',
  text: 'Descarga inmediata y todo muy bien organizado. El soporte también es excelente. 10/10.',
  stars: 5
}];
export function ReviewsGrid() {
  return <section id="resenas" className="py-8 px-4" style={{
    backgroundColor: '#000000'
  }} data-id="element-216">
      <div className="max-w-5xl mx-auto" data-id="element-217">
        <h2 className="text-center text-2xl sm:text-3xl font-bold text-white mb-2" style={{
        fontFamily: "'Playfair Display', serif"
      }} data-id="element-218">
          Reseñas de nuestros detectives 🔎
        </h2>
        <p className="text-center text-gray-500 text-sm mb-6" data-id="element-219">
          Más de 76 detectives satisfechos · Valoración media{' '}
          <span style={{
          color: '#f0c040'
        }} className="font-bold" data-id="element-220">
            4.5/5
          </span>
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-221">
          {reviews.map(review => <div key={review.name} className="p-4 rounded-lg flex flex-col gap-3" style={{
          backgroundColor: '#111111',
          border: '1px solid #222',
          borderLeft: `3px solid ${review.color}`
        }} data-id="element-222">
              {/* Stars */}
              <div className="flex gap-0.5" data-id="element-223">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} size={13} fill={i <= review.stars ? '#f0c040' : 'none'} stroke="#f0c040" strokeWidth={1.5} data-id="element-224" />)}
              </div>

              {/* Text */}
              <p className="text-gray-300 text-sm leading-relaxed flex-1 italic" data-id="element-225">
                "{review.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-2 pt-2" style={{
            borderTop: '1px solid #222'
          }} data-id="element-226">
                <div className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0" style={{
              backgroundColor: review.color
            }} data-id="element-227">
                  {review.initials}
                </div>
                <div data-id="element-228">
                  <p className="text-white text-xs font-semibold" data-id="element-229">
                    {review.name}
                  </p>
                  <div className="flex items-center gap-1" data-id="element-230">
                    <CheckCircle size={10} style={{
                  color: '#27ae60'
                }} data-id="element-231" />
                    <span className="text-xs" style={{
                  color: '#27ae60',
                  fontSize: '0.65rem'
                }} data-id="element-232">
                      Compra verificada
                    </span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}